import { render, staticRenderFns } from "./LoginHistoryList.vue?vue&type=template&id=b28df2c0&"
import script from "./LoginHistoryList.vue?vue&type=script&lang=js&"
export * from "./LoginHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports